import { assert_array_not_empty, assert_array_object_id, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_REQUEST__grid2d_get_by_entity_type_and_id } from './DTO_REQUEST__grid2d_get_by_entity_type_and_id';

export class DTO_REQUEST__grid2d_chunk_load_cells extends DTO_REQUEST__grid2d_get_by_entity_type_and_id {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GRID2D_CHUNK_LOAD_CELLS;

  /*
   * FIELDS
   */
  grid2d_id!: string;
  grid2d_chunk_ids!: string[];

  /*
   * METHODS
   */

  constructor() {
    super();
    this.grid2d_chunk_ids = [];
  }

  override assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_object_id(this.grid2d_id);
    assert_array_not_empty(this.grid2d_chunk_ids);
    assert_array_object_id(this.grid2d_chunk_ids);
  }
}
